<template>
  <div v-if="customer && customer.id" class="hide-cancel">
    <modalWindow v-model="showModel" @cancel="cancel()" @ok="cancel()" @closed="onClose()" :title="customer.companyName" okText="Zavrieť" cancelText="Zrušiť">
      <div class="row">
        <div class="col-md-12">
          <dl class="dl-horizontal">
            <dt>Typ prevádzky</dt>
            <dd>{{ customer.businessType | codeListValue(businessTypes) }}</dd>
            <dt>Oblasť</dt>
            <dd>{{ customer.area.label }}</dd>
            <dt>Adresa</dt>
            <dd>
              <address>
                {{ customer.address.streetName }} {{ customer.address.streetNumber }}<br>
                {{ customer.address.zipCode }} {{ customer.address.city }}<br>
              </address>
            </dd>
            <dt>Požaduje dodací list</dt>
            <dd><i class="fa" :class="{'fa-check text-success': customer.deliveryNote, 'fa-times text-danger': !customer.deliveryNote}"></i></dd>
            <dt>Poznámka</dt>
            <dd>{{ customer.note }}</dd>
            <dt v-if="customer.parent">Je pobočkou</dt>
            <dd v-if="customer.parent">{{ customer.parent.companyName }}</dd>
            <dt>IČO</dt>
            <dd>{{ customer.companyId }}</dd>
            <dt>DIČ</dt>
            <dd>{{ customer.taxId }}</dd>
            <dt v-if="customer.vatId">IČ DPH</dt>
            <dd v-if="customer.vatId">{{ customer.vatId }}</dd>
            <dt>Adresa</dt>
            <dd>
              <address>
                {{ customer.address.streetName }} {{ customer.address.streetNumber }}<br>
                {{ customer.address.zipCode }} {{ customer.address.city }}<br>
              </address>
            </dd>
          </dl>
        </div>
      </div>
      <div class="row">
        <hr>
        <div class="col-xs-6">
          <strong>Cenník</strong>
          <table class="table table-hover" v-if="priceList">
            <tbody>
            <tr v-for="item in priceList.items">
              <td>{{ item.product.label }}</td>
              <td>{{ item.price | currency }}</td>
            </tr>
            </tbody>
          </table>
          <alert type="warning" v-else>Neexistuje platný cenník.</alert>
        </div>
        <div class="col-xs-6" v-if="customer.branches.length">
          <strong>Pobočky</strong>
          <table class="table table-hover">
            <tbody>
            <tr v-for="branch in customer.branches">
              <td>{{ branch.companyName }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modalWindow>
  </div>
</template>

<script>
  import modal from 'vue-strap/src/Modal';
  import { alert } from 'vue-strap';
  import { mapState } from 'vuex';
  import { businessTypes } from 'codelist/';

  export default {
    components: {modalWindow: modal, alert},
    data() {
       return {
         businessTypes: businessTypes
       }
    },
    props: {
      showModel: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object
      },
    },
    computed: {
      ...mapState({
        priceList: (state) => state.priceList.current
      }),
      customer() {
          return this.model;
      }
    },
    methods: {
      onClose() {
        this.$store.dispatch('priceList/clearCurrent');
        this.unprotect();
      },
      cancel() {
        this.protect();
        this.$emit('close');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/customerDetailModal.vue